import './loader.scss';

export default function Loader({ message = "" }) {
  return (
    <div className="loader-wrapper">
      <div className="spinner"></div>
      <p className="loading-text">{message}</p>
    </div>
  );
}
